import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'appointment-form',
  'virtual-visit-providers',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    'virtual_visits',
    'providers',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/virtual-visit-providers-req.js